import { GetDamagedAdjusterDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterDocumentImages/getDamagedAdjusterDocumentImagesQuery.type';
import { getDamagedAdjusterDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterDocumentImages/getDamagedAdjusterDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedAdjusterDocumentImagesQueryOptions = (
  params: GetDamagedAdjusterDocumentImagesQueryParamsType,
) =>
  queryOptions({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'AdjusterDocumentImages',
      params.id,
      params.type,
      params.type === 'damaged' ? params.damagedId : undefined,
    ],
    queryFn: () => getDamagedAdjusterDocumentImagesFunction(params),
    enabled: true,
  });
